import type { ReactNode } from 'react';
import { Link, usePathname } from './router.js';

/** Navigate by Apps: the shell of the Workspace, an App and a Bulk Run. */
export function AtlasRail({ onSignOut }: { onSignOut: () => void }): ReactNode {
  const pathname = usePathname();
  const items = [
    { to: '/', label: 'Workspace' },
    { to: '/store-designs/new', label: 'Создать оформление' },
    // Every Store Listing and what it shows in every country.
    { to: '/inventory', label: 'Inventory' },
    { to: '/bulk-runs', label: 'Bulk Runs' },
    // Where generation runs, and why a key is not being used. R187.
    { to: '/settings/providers', label: 'Providers' },
  ];

  return (
    <aside className="atlas-rail" aria-label="Навигация Workspace">
      <div className="brand">
        <span className="brand-mark" aria-hidden="true" />
        <span>Creative Studio</span>
      </div>
      <nav className="atlas-nav">
        {items.map((item) => (
          <Link key={item.to} to={item.to} className={pathname === item.to ? 'active' : ''}>
            {item.label}
          </Link>
        ))}
      </nav>
      <div className="rail-foot">
        <button className="ghost" type="button" onClick={onSignOut}>
          Выйти
        </button>
      </div>
    </aside>
  );
}
